// Helpers de slide (animacao para o .results)
function SlideDown(el, duration) {
  duration = duration || 300;
  el.style.removeProperty('display');
  let display = window.getComputedStyle(el).display;
  if (display === 'none') display = 'block';
  el.style.display = display;
  const height = el.offsetHeight;
  el.style.overflow = 'hidden';
  el.style.height = '0px';
  el.style.paddingTop = '0';
  el.style.paddingBottom = '0';
  el.style.marginTop = '0';
  el.style.marginBottom = '0';
  void el.offsetHeight;
  el.style.transitionProperty = 'height, margin, padding';
  el.style.transitionDuration = duration + 'ms';
  el.style.height = height + 'px';
  el.style.removeProperty('padding-top');
  el.style.removeProperty('padding-bottom');
  el.style.removeProperty('margin-top');
  el.style.removeProperty('margin-bottom');
  setTimeout(() => {
    el.style.removeProperty('height');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition-duration');
    el.style.removeProperty('transition-property');
  }, duration);
}

var _freteCalculando = false;

function _produto() {
  if (_freteCalculando) {
    console.log('Calculo de frete ja em andamento, ignorando chamada duplicada.');
    return;
  }

  const cepEl = document.querySelector('.product-shipping #billing_cep');
  const productIdEl = document.querySelector('form .product-variant-id');
  const quantityInput = document.querySelector('input[name="quantity"]');
  const stockEl = document.querySelector('#variant-stock');
  const shippingEl = document.querySelector('.product-shipping');
  const resultsEl = document.querySelector('.product-shipping .results');

  if (!cepEl || !productIdEl) return;

  let postalCode = cepEl.value;
  const productId = productIdEl.value;
  const quantity = parseInt(quantityInput && quantityInput.value, 10) || 1;
  const availableStock = parseInt(stockEl && stockEl.value, 10);

  console.log('Quantidade selecionada:', quantity);

  if (quantity > availableStock) {
    alert('Nao e possivel calcular o frete: a quantidade excede o estoque disponivel.');
    if (shippingEl) shippingEl.classList.remove('waiting');
    return;
  }

  console.log('Product ID:', productId, 'Quantity:', quantity);

  let originalCartItems = [];

  postalCode = postalCode.trim().replace('-', '');

  if (resultsEl) resultsEl.style.display = 'none';
  if (shippingEl) shippingEl.classList.add('waiting');

  if (postalCode === '') {
    if (resultsEl) resultsEl.style.display = 'none';
    if (shippingEl) shippingEl.classList.remove('waiting');
    return;
  }

  _freteCalculando = true;

  fetch('https://opencep.com/v1/' + postalCode + '.json')
    .then(function(r) {
      if (!r.ok) throw new Error('CEP request failed');
      return r.json();
    })
    .then(function(data) {
      if (data.error) {
        alert('CEP invalido. Por favor, tente novamente.');
        if (resultsEl) resultsEl.style.display = 'none';
        if (shippingEl) shippingEl.classList.remove('waiting');
        _freteCalculando = false;
        return Promise.reject('cep-invalido');
      }
      var state = data.uf;

      return fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cartData) {
          originalCartItems = cartData.items;

          return fetch('/cart/clear.js', { method: 'POST' })
            .then(function() {
              console.log('Carrinho limpo.');
              var formData = new FormData();
              formData.append('id', productId);
              formData.append('quantity', String(quantity));

              return fetch('/cart/add.js', { method: 'POST', body: formData })
                .then(function(r) {
                  if (!r.ok) {
                    return r.text().then(function(txt) {
                      var parsed = {};
                      try { parsed = JSON.parse(txt); } catch (e) {}
                      console.log('Erro ao adicionar produto:', txt);
                      alert('Erro ao adicionar ao carrinho: ' + (parsed.description || 'Verifique o estoque.'));
                      if (shippingEl) shippingEl.classList.remove('waiting');
                      return restoreOriginalCart(originalCartItems).then(function() {
                        _freteCalculando = false;
                      });
                    });
                  }
                  return r.json();
                })
                .then(function(addResponse) {
                  if (!addResponse || typeof addResponse !== 'object' || !addResponse.id) return;

                  console.log('Produto adicionado com quantidade:', quantity);

                  return new Promise(function(resolve) { setTimeout(resolve, 500); }).then(function() {
                    var params = new URLSearchParams({
                      'shipping_address[zip]': postalCode,
                      'shipping_address[country]': 'BR',
                      'shipping_address[province]': state
                    });
                    return fetch('/cart/shipping_rates.json?' + params.toString())
                      .then(function(r) {
                        if (!r.ok) throw new Error('shipping_rates failed');
                        return r.json();
                      })
                      .then(function(shippingData) {
                        console.log('Dados de frete recebidos:', shippingData);
                        var rates = shippingData.shipping_rates || [];
                        var resultHtml = '';
                        if (rates.length > 0) {
                          rates.forEach(function(rate) {
                            var price = parseFloat(rate.price).toFixed(2).replace('.', ',');
                            var deliveryInfo = rate.delivery_days && rate.delivery_days[0]
                              ? rate.delivery_days[0] + ' dias uteis'
                              : '';
                            resultHtml += '<p>' +
                              '<span class="rate-name">' + rate.name + ':</span> ' +
                              'R$ ' + price + ' ' +
                              '<span class="rate-days">' + deliveryInfo + '</span> ' +
                              '<small class="quantity-info">(' + quantity + ' ' + (quantity === 1 ? 'unidade' : 'unidades') + ')</small>' +
                              '</p>';
                          });
                        } else {
                          resultHtml = '<p>Nao foi possivel calcular o frete para esta quantidade.</p>';
                        }

                        if (resultsEl) {
                          resultsEl.innerHTML = resultHtml;
                          SlideDown(resultsEl);
                        }
                        if (shippingEl) shippingEl.classList.remove('waiting');
                        return restoreOriginalCart(originalCartItems).then(function() {
                          _freteCalculando = false;
                        });
                      })
                      .catch(function(err) {
                        console.log('Erro ao calcular frete:', err);
                        alert('Erro ao calcular o frete. Por favor, tente novamente.');
                        if (shippingEl) shippingEl.classList.remove('waiting');
                        return restoreOriginalCart(originalCartItems).then(function() {
                          _freteCalculando = false;
                        });
                      });
                  });
                });
            })
            .catch(function(err) {
              console.log('Erro ao limpar o carrinho:', err);
              if (shippingEl) shippingEl.classList.remove('waiting');
              _freteCalculando = false;
            });
        })
        .catch(function() {
          console.log('Erro ao obter o conteudo do carrinho.');
          if (shippingEl) shippingEl.classList.remove('waiting');
          _freteCalculando = false;
        });
    })
    .catch(function(err) {
      if (err === 'cep-invalido') return;
      alert('CEP invalido. Por favor, tente novamente.');
      if (resultsEl) resultsEl.style.display = 'none';
      if (shippingEl) shippingEl.classList.remove('waiting');
      _freteCalculando = false;
    });
}

function restoreOriginalCart(originalCartItems) {
  return fetch('/cart/clear.js', { method: 'POST' })
    .then(function() {
      if (!originalCartItems || originalCartItems.length === 0) return Promise.resolve();
      var chain = Promise.resolve();
      originalCartItems.forEach(function(item) {
        chain = chain.then(function() {
          var formData = new FormData();
          formData.append('id', item.id);
          formData.append('quantity', item.quantity);
          return fetch('/cart/add.js', { method: 'POST', body: formData })
            .then(function(r) { return r.json(); })
            .then(function() {
              console.log('Produto restaurado: ' + item.title);
            })
            .catch(function() {
              console.log('Erro ao restaurar o produto: ' + item.title);
            });
        });
      });
      return chain;
    });
}

document.addEventListener('DOMContentLoaded', function() {
  var qtyInput = document.querySelector('input[name="quantity"]');
  var cepInput = document.querySelector('.product-shipping #billing_cep');

  function recalcularFrete(origem) {
    var cep = cepInput && cepInput.value;
    if (cep && cep.trim() !== '') {
      clearTimeout(window._freteDebounce);
      window._freteDebounce = setTimeout(function() {
        console.log('Recalculando frete por ' + origem + '...');
        _produto();
      }, 500);
    }
  }

  if (qtyInput) {
    ['change', 'input'].forEach(function(ev) {
      qtyInput.addEventListener(ev, function() {
        recalcularFrete('mudanca no input');
      });
    });
  }

  document.querySelectorAll('.quantity__button').forEach(function(btn) {
    btn.addEventListener('click', function() {
      recalcularFrete('clique no botao');
    });
  });

  if (cepInput) {
    cepInput.addEventListener('change', function() {
      if (this.value.trim() !== '') {
        clearTimeout(window._freteDebounce);
        console.log('Calculando frete por mudanca no CEP...');
        _produto();
      }
    });
  }

  if (window.MutationObserver && qtyInput) {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
          recalcularFrete('mudanca no valor (observer)');
        }
      });
    });
    observer.observe(qtyInput, { attributes: true, attributeFilter: ['value'] });
  }
});
